import { Link } from "react-router-dom";

import { LegalPage } from "@/components/legal/legal-page";
import { PRIVACY_PATH } from "@/components/legal/legal-footer";
import { SellerEmail, SellerIdentity } from "@/components/legal/seller-details";
import { LEGAL_DRAFT, LEGAL_UPDATED } from "@/pages/legal/legal-meta";

/**
 * Naudojimosi taisyklės — /taisykles, public.
 *
 * PLACEHOLDER TEXT (issue #40). It describes what the app actually does today,
 * so the draft is not wrong about the product, but it is not legal advice and
 * the lawyer's text replaces it whole. Bracketed parts are facts nobody has
 * filled in yet; the seller's details come from `lib/seller.ts`.
 */
export default function TermsPage() {
  return (
    <LegalPage title="Naudojimosi taisyklės" updated={LEGAL_UPDATED} draft={LEGAL_DRAFT}>
      <section>
        <h2>1. Kas mes</h2>
        <p>
          Scio — mokymosi programa vaikams: užduotys pagal dalyką, klasę ir sunkumą,
          teorija ir pagalbininkas, kuris padeda išsiaiškinti klaidas. Programą
          valdo <SellerIdentity />. Susisiekti galite adresu <SellerEmail />.
        </p>
      </section>

      <section>
        <h2>2. Paskyros</h2>
        <ul>
          <li>
            Paskyrą gali susikurti tėvai ar globėjai, o jie — pridėti savo vaikus.
            Paskyrą kuria tėvai ar globėjai, vaikai naudojasi profiliu tėvų
            paskyroje. Už vaiko profilį atsako jį prižiūrintis suaugęs.
          </li>
          <li>
            Už savo prisijungimo duomenų saugumą atsakote jūs. Jei manote, kad
            kažkas jais pasinaudojo, praneškite mums.
          </li>
          <li>
            Jūsų įvestas el. pašto adresas turi būti jūsų — jį patvirtinate
            paspausdami laiške atsiųstą nuorodą.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Dirbtinis intelektas</h2>
        <p>
          Dalį programos atsakymų parengia dirbtinis intelektas (AI): pokalbis apie
          klaidą, atsakymo patikrinimas, užduočių pritaikymas vaiko pomėgiams ir
          pažangos laiškai. Tai pažymėta ten, kur vyksta. AI gali suklysti — jei
          užduotis ar atsakymas atrodo neteisingi, praneškite per „Kažkas negerai su
          šia užduotimi“.
        </p>
      </section>

      <section>
        <h2>4. Prenumerata ir mokėjimai</h2>
        <p>
          Dalis funkcijų prieinama tik su prenumerata. Mokėjimus tvarko „Stripe“; mes
          kortelės duomenų nematome ir nesaugome. [Kaina, atsiskaitymo laikotarpis,
          atsisakymo ir pinigų grąžinimo tvarka.]
        </p>
      </section>

      <section>
        <h2>5. Ko daryti negalima</h2>
        <ul>
          <li>Naudotis kito žmogaus paskyra be jo leidimo.</li>
          <li>Bandyti pasiekti kitų šeimų duomenis ar trikdyti programos veikimą.</li>
          <li>Kopijuoti ir platinti užduotis kaip savo produktą.</li>
        </ul>
      </section>

      <section>
        <h2>6. Atsakomybė</h2>
        <p>
          Stengiamės, kad užduotys ir atsakymai būtų teisingi, bet negalime garantuoti,
          kad klaidų nebus. Programa papildo mokymąsi, o ne pakeičia mokyklą ar
          mokytoją. [Atsakomybės ribojimas.]
        </p>
      </section>

      <section>
        <h2>7. Paskyros panaikinimas</h2>
        <p>
          Paskyrą galite ištrinti nustatymuose arba parašę mums. Kaip elgiamės su
          duomenimis, aprašyta{" "}
          <Link to={PRIVACY_PATH} className="underline underline-offset-4">
            privatumo politikoje
          </Link>
          .
        </p>
      </section>

      <section>
        <h2>8. Taisyklių pakeitimai</h2>
        <p>
          Jei taisyklės pasikeis iš esmės, apie tai pranešime prieš įsigaliojant
          pakeitimams. [Taikoma teisė ir ginčų sprendimo tvarka.]
        </p>
      </section>
    </LegalPage>
  );
}
